module.exports = __webpack_public_path__ + "assets/img/82128339737e46a191c86e562e4a106f.png";